// extracted by mini-css-extract-plugin
module.exports = {"container":"section4_container__aBWHB","content":"section4_content__QlQPV","title":"section4_title__5i8eI","cards":"section4_cards__8_IKv"};